"use client";

interface SectionHeaderProps {
  label: string;
  startMeasure: number;
  endMeasure: number;
  color: string;
  isExpanded: boolean;
  isLooped: boolean;
  onToggleExpand: () => void;
  onToggleLoop: () => void;
}

export function SectionHeader({
  label,
  startMeasure,
  endMeasure,
  color,
  isExpanded,
  isLooped,
  onToggleExpand,
  onToggleLoop,
}: SectionHeaderProps) {
  return (
    <div
      onClick={onToggleExpand}
      className="relative flex items-center gap-2 px-2 py-1.5 text-left cursor-pointer transition-colors duration-100 hover:bg-white/[0.03] rounded-md group"
    >
      {/* Colored left bar */}
      <div
        className="w-1 self-stretch rounded-full shrink-0"
        style={{ backgroundColor: color }}
      />

      {/* Expand chevron */}
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="currentColor"
        className={`text-text-muted transition-transform duration-150 shrink-0 ${
          isExpanded ? "rotate-90" : ""
        }`}
      >
        <path d="M3 1l4 4-4 4z" />
      </svg>

      {/* Label + bar range */}
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-xs font-semibold text-text-primary leading-tight truncate">
          {label}
        </span>
        <span className="text-[9px] text-text-muted leading-none">
          Bar {startMeasure}–{endMeasure}
        </span>
      </div>

      {/* Loop section button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggleLoop();
        }}
        className={`shrink-0 w-6 h-6 flex items-center justify-center rounded transition-all duration-150 cursor-pointer ${
          isLooped
            ? "bg-accent text-white shadow-[0_0_8px_rgba(139,92,246,0.4)]"
            : "text-text-muted hover:text-accent-bright hover:bg-white/[0.05]"
        }`}
        title={isLooped ? "Remove loop" : `Loop ${label}`}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 14 14"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        >
          <path d="M1.5 5h9M8.5 3l2 2-2 2" />
          <path d="M12.5 9h-9M5.5 7l-2 2 2 2" />
        </svg>
      </button>
    </div>
  );
}
